'use client'

import type { LucideIcon } from 'lucide-react'

import { cn } from '../cn'

interface ViewOption {
  id: string
  label: string
  icon: LucideIcon
  disabled?: boolean
  disabledReason?: string
}

interface ViewToggleProps {
  views: ViewOption[]
  activeView: string
  onChange: (view: string) => void
  iconOnly?: boolean
}

function ViewToggle({ views, activeView, onChange, iconOnly = false }: ViewToggleProps) {
  return (
    <div className="inline-flex items-center rounded-lg border border-border bg-background p-0.5">
      {views.map((view) => {
        const Icon = view.icon
        const isActive = view.id === activeView
        return (
          <button
            key={view.id}
            type="button"
            disabled={view.disabled}
            onClick={() => {
              if (!view.disabled) {
                onChange(view.id)
              }
            }}
            title={view.disabledReason ?? view.label}
            className={cn(
              'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors',
              iconOnly ? 'p-1.5' : 'gap-1.5 px-3 py-1.5',
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-accent',
              view.disabled && 'cursor-not-allowed opacity-50 hover:bg-transparent hover:text-muted-foreground',
            )}>
            <Icon className="h-4 w-4" />
            {!iconOnly && view.label}
          </button>
        )
      })}
    </div>
  )
}

export { type ViewOption, ViewToggle, type ViewToggleProps }
